
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq-sub-categories/[slug]",
      function () {
        return require("private-next-pages/faq-sub-categories/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq-sub-categories/[slug]"])
      });
    }
  